module.exports = {
  login: {
    title: 'ログイン',
    rememberPsd: 'パスワードを覚える',
    // forgetPsd:'パスワードを忘れてしまう',
    forgetPsd: 'パスワードを忘れる',
    signIn: 'ログイン',
    signUp: '登録',
    enteraccount: 'メールアドレス/携帯番号',
    accountnot: 'アカウントが存在しない',
    accountpassword: 'パスワード',
    entercode: '検証コードを入力してください',
    ApplyQrCode: '迷子犬捜し用ペンダントを申請する',
    ThirdPartyLogin: 'サードパーティのログイン',
    accountLength: 'アカウントの長さが最大の32に達しました',
    passwordLength: 'パスワードの長さが最大の16ビットに達しました',
    noAccOrPsd:'アカウントパスワードが空になってはいけません',
    enterid:'製品idを入力する',
    scanphone:'写真掃除',
    platform:'Dogness platform',
    areaCode:'国家と地域',
    agree:'Logging in is agreeing to a',
    privacyStatement:'privacy policy',
    setLoginPsw:'ログインパスワードを設定し、パスワードを確認してください',
    pswSimple:'パスワードは簡単すぎる!'
  },
  btn: {
    text: 'ボタン'
  },
  btmNavBar: {
    device: 'デバイス',
    finder: '捜査協力',
    my: '私の'
  },
  finder: { //协寻列表
    find: '捜査協力',
    filtrateTime: '時間', //时间筛选
    filtrateDis: '距離', //距离筛选
    noMoreFind: 'これ以上の捜査情報はない',
    pullRefresh: 'プルダウンリフレッシュ',
    noComment:'まだ評論なし',
    noMoreComment:'全てのコメントが示されています',
    comments:'最新評論',
    enterComment:'コメントの内容を入力してください!',
    notAccount:'コメント情報を登録してみてください'
  },
  device: { //设备列表
    noLogin: 'ログインしてない、ログインしてからデバイスを確認してください',
    myDevice: '私のデバイス',
    deviceNull: 'まだドッグネスの人工知能デバイスを追加していない',
    goLogin: '登録する',
    deviceCode: 'デバイスの番号',
    bindPet: 'バインディングしたペット',
    noBindPet: 'このデバイスはペットとバインドされていない',
    hint: 'デバイスを削除する場合は、ペットとのバインディングを解除してから、削除してください。',
    unbind: 'バインディングを解除する',
    delDevice: '削除',
    addNewDevice: '新デバイスを追加する',
    nobindDevice: 'DOGNESSのどのデバイスにもバインドされていない',
    isDelete: 'デバイスを削除する?',
    deleteDevice: 'デバイスを削除する'
  },
  addDevice: {
    scanQRC: 'QRコードをスキャンします',
    makePhotoSign: 'カメラボタンを押して装置の二次元コードを接続する',
    ifConntRecog: 'もし試してみることができないなら',
    inputQRC: 'QRコード番号を入力する',
    recogQRC: '選択されたQRコードを識別する',
    reMake: 'リメイク',
    chackYourId: 'デバイスIDは以下の通り。',
    bingDev: '結び付け設備',
    cancel: 'キャンセル',
    recogging: 'QRコードを認識していますので、後ほどお願いします...',
    conntRecog: '選挙区内のQRコードを認識せずに、QRコードかミクロ選挙に合わせてください',
    QRCcontent: '識別されたQRコードコンテンツ',
    sure: '確定',
    successBind: '結び付けが成功する',
    alreadyBinged: 'この装置はバインディングされた',
    notexist:'設備は存在しない!'
  },
  bindById: {
    inputId: 'IDバインディング装置を入力する',
    pleaseInput: '装置QRコード番号を入力してください',
    sureBind: '結び付けを確認する',
    successBind: '結び付けが成功する',
    alreadyBinged: 'この装置はバインディングされた',
    faileBind: 'バインディングに失敗しました、正しい装置番号を入力してください',
    cannotBind:'この装置はハンストではなく、バインディングすることができない'
  },
  my: {
    myAccount: "私のユーザー",
    myPet: "私のペット",
    masterInfo: '飼い主さん情報',
    myFinder: '私からの捜索依頼',
    changePsd: 'パスワードを修正する',
    onlineService: 'オンラインサポート',
    FAQ: 'よくある問題',
    exit: 'ログアウト',
    isExit:'登極するかどうか',
    myname:'主人の名前'
  },
  searchmessage:{
    title:'タイトル',
    describe:'協力プロフィール',
    petphone:'ペットの写真'
  },
  mysearch: {
    status: '状態',
    finding: '捜している',
    finded: '見つかった',
    closed: '終了',
    time: '時間',
    // publishFind: '捜査協力呼びかけを公開する',
    publishFind: '協力探しをする',
    // clickToCheck: 'スキャンコード記録を検索する',
    clickToCheck: '記録を調べる',
    losePlace: '迷子になった場所',
    loseTime: '迷子になった時間',
    stopfind: '捜索中のペットがいない',
    nofindpet: '見つかったペットは現在いない',
    nostoppet: '保管中のペットは現在いない',
    success:'リリース成功',
    lost:'投稿に失敗しました',
  },
  changefindpetinfo: {
    changefind: '捜査協力情報を修正する',
    findPet: '捜査依頼のペット',
    clickToChangePlace: '下をクリックして場所を変更出来る',
    petPhotos: 'ペット写真（3枚まで）',
    publicRelation: '連絡方法を公開する',
    findStatus: '捜査状況',
    commit: '提出する',
    more: '複数の選択が可能',
    select: '選択してください',
    enterTitle: '20文字以下のタイトルを入力してください',
    describe: '愛愛愛、逃避状況について、詳しく記述してください',
    change: '修正中、少々お待ちください。',
    failure: '申請失敗'
  },
  masterInfo: {
    masterInfo: '飼い主さんが情報',
    nickName: 'ニックネーム',
    sex: '性別',
    email: 'メールアドレス',
    phone: '連絡用電話番号',
    add: '連絡用住所'
  },
  changepassword: {
    oldPsd: '古いパスワードを入力してください',
    newPsd: '新しいパスワードを入力してください',
    againPsd: '新しいパスワードをもう一度入力してください',
    trueChange: '修正を確認する',
    notPsd: 'パスワード欄を空にしてはいけない',
    falsePsd: 'パスワードが一致しません',
    lessPsd: 'パスワードが間違い',
    notSamePsd: 'パスワードが一致していない'
  },
  petDetails: {
    find: '捜査依頼',
    findInfo: '捜査依頼情報の詳細',
    petintro: 'ペットの紹介',
    relationPer: '連絡先',
    relationWay: '連絡方法',
    relHelp: '関連する捜査情報',
    share: '共有先',
    cancelshare: '共有をキャンセルする',
    wx: 'これはWeChatブラウザです',
    lost: '住所を失う'
  },
  addpet: {
    cat:'猫',
    dog:'犬',
    addpet: "ペットを追加する",
    setPetPortrait: 'ヘッドの写真を設置する',
    petName: 'ペットのニックネーム',
    petType: 'ペットの品種',
    color: 'ペットの色',
    sex: 'ペットの性別',
    weight: 'ペットの体重',
    height: 'ペットの高さ',
    birthday: 'ペットの誕生日',
    character: 'ペットの性格',
    trueAdd: '追加を確認する',
    flag2: '中国語、英語、数字、下線、マイナス記号しか使用できない',
    notpetName: 'ペットの名前は記入されていない',
    enterchinese: '中国語や英語を入力してください',
    notpetType: 'ペットの品種は記入されていない',
    notpetColor: 'ペットの色は記入されていない',
    notpetSex: 'ペットの性別は記入されていない',
    not: '数字だけです',
    enterweight: 'ペットの体重を入力する',
    enterheight: 'ペットの高さを入力する',
    notWeight: 'ペットの体重はまた記入されていない',
    notHeight: 'ペットの高さはまた記入されていない',
    selectData: '日付を選択する',
    selectSex: '性別を選択する',
    notBirthday: '生年月日はまた選択されていない',
    entercharacter: '性格を入力する',
    notcharacter: 'ペットの性別は記入されていない',
    entername: 'ペットの名称を入力する',
    enterType: 'ペットの品種を入力する',
    enterColor: 'ペットの色を入力する',
    have: '空にしてはいけない',
    savechage: '修正を保存する',
    petNews: 'ペット情報',
    deletePet: 'ペット情報を削除する',
    report: '捜査協力情報を発表する',
    submiting: '提出中、少々お待ちください'
  },
  mapinfo: {
    sure: '確定'
  },
  privacyStatement:{
    appPrivacy:'アプリのプライバシーに関する声明',
    addEnglish:'',
    addEnglish1:'',
    phead:'「Dogness」はお客様のプライバシーを尊重しています。一定の情報があるからこそ、ユーザーから望まれたサービスを提供することができる場合があります。このプライバシーに関する声明では、個人データの収集、使用について説明します。このプライバシーに関する声明は、DognessAppのすべての関連サービスに適用されます。',
    one:'個人情報の収集',
    addEnglish2:'',
    onecontent:'あなたの（個人情報）または連絡先を収集する場合、我々はあなたの同意を得てから行います。',
    two:'個人情報の利用について',
    twocontent:'「Dogness」は、法律または Dogness の関連サービス条件、およびソフトウェア使用許諾契約に従って必要とされる場合、お客様の個人情報を開示します。あるいは、十分の理由がある時しか行いません。（a）法律の規定に従うこと（b）「Dogness」関連サービス条項、ソフトウェア使用許諾協議の約束に従うこと、（c）Dogness の権利または財産の保護、および（d）緊急時の Dogness 従業員、Donnes 製品、サービスを受けている Dogness ユーザーの安全を保護すること。',
    twocontent1:'Dogness は、この声明に記載されている状況を除き、この情報を第三者と無断で共有することはありません',
    three:'個人情報のセキュリティ',
    threecontent:'個人情報のセキュリティを厳重に保護します。我々は、お客様の個人情報を不正なアクセス、使用または開示から保護するために、さまざまなセキュリティ技術とプログラムを使用しています。',
   
    addEnglish3:'',
    addEnglish4:'',
    addEnglish5:'',
    addEnglish6:'',
    addEnglish7:'',
    addEnglish8:'',
    addEnglish9:'',
    addEnglish10:'',
    addEnglish11:'',
    addEnglish12:'',
    addEnglish13:'',
    addEnglish14:'',
    addEnglish15:'',
    addEnglish16:'',
    addEnglish17:'',
    addEnglish18:'',
    addEnglish19:'',
    addEnglish20:'',
    addEnglish21:'',
    addEnglish22:'',
    addEnglish23:'',
    addEnglish24:'',
    addEnglish25:'',
    addEnglish26:'',
    addEnglish27:'',
    addEnglish28:'',
    addEnglish29:'',
    addEnglish30:'',
    addEnglish31:'',
    addEnglish32:'',
    addEnglish33:'',
    addEnglish34:'',
    addEnglish35:'',
    addEnglish36:'',
    addEnglish37:'',
    addEnglish38:'',
   
    four:'免責について',
    fourcontent:' 次の関連事項が発生したときに、「Dogness」はいかなる法律責任を負いません：',
    fourcontent1:'「Dogness」は、法律の規定や政府の要求によって、あなたの個人情報を提供する時;',
    fourcontent2:'「Dogness」の原因以外による個人情報の漏洩場合；',
    fourcontent3:'「Dogness」のさまざまなサービス条件および声明に定められた条件に従って、第三者がお客様の個人情報を使用することによって起因する紛争；',
    fourcontent4:'ハッキング、コンピュータウイルス侵入または政府規制に起因する一時的なサービス停止場合；',
    fourcontent5:'不可抗力によって生じたいかなる結果；',
    fourcontent6:'《多尼斯》在各服务条款及声明中列明的免责情形 。',
    
    addEnglish39:'',
    addEnglish40:'',
    addEnglish41:'',
    addEnglish42:'',
    addEnglish43:'',
    addEnglish44:'',
    addEnglish45:'',
    addEnglish46:'',
    addEnglish47:'',
    addEnglish48:'',
    addEnglish49:'',
    addEnglish50:'',
    addEnglish51:'',
    addEnglish52:'',
    
    five:'隐私声明的修订：',
    fivecontent:'根据需要，将随时修改本隐私声明。我们建议用户定期上网查看最新的隐私政策于使用条款规定。未来任何条款如有更新，我们将不主动提醒用户，亦不会回溯应用在之前所发生的情形，同时不会改变我们对于之前所收集的资料之处理方式。',
    fivecontent1:'お問い合わせ先：service@dognesstech.com',
    
    addEnglish53:'',
    addEnglish54:''
  },
  userInformation: {
    changeImg: '写真をクリックして、削除して更新ができる',
    enterusername: 'ニックネームを入力する',
    username: 'ニックネーム',
    phonenumber: '携帯電話番号',
    email: 'メールアドレス',
    savechage: '修正を保存する'
  },
  //sharon
  complete: {
    finishregister: '登録完了、おめでとう',
    gologin: 'すぐログインする'
  },
  emailproving: {
    register: 'アカウントを登録する',
    lastStep: 'あと一歩登録完了',
    textone: '私たちはすでにあなたのメールアドレスにアクティブ用メールを送りました。，',
    texttwo: 'メールのリンクをクリックして登録を完了してください！',
    resend: 'メールを受信していない場合は、[再送信]をクリックしてください！',
    ActivateAccount: 'メールボックスに入ってアカウントをアクティブにする'
  },
  forgetpassword: {
    resetpassword: 'パスワードをリセットする',
    resetpasswordphone: 'アイフォンのパスワードをセットする',
    resetpasswordemail: 'メールのパスワードをリセットする',
    setpassword:'パスワードの設定',
    //手机在重置密码
    EnterPhone: '携帯電話の番号を入力してください',
    FalsePhone: '携帯番号のフォーマットが正しくない',
    NoPhone: '携帯番号は登録されていない',
    NotPhone: '携帯番号は空けてはいけない',
    NotCode: '検証コードは空けてはいけない!',
    NoMatch: '検証コードが正しくない!',
    next: '次のステップ',
    HadAccount: 'すでにアカウントが登録されている',
    sendcode: '検証コードを送信する',
    sendcode2:'送信',
    sendContent2:'コメントの内容を入力してください',
    // verify:'クリックして検証する',
    verify: 'クリック検証',
    resend: 'もう一度送信する',
    notresend: 'メールを繰り返して送ることはできません。',
    //邮箱在重置密码
    EnterEmail: 'メールアドレスを入力してください',
    FalseEmail: 'メールのフォーマットが正しくない',
    NoEmail: 'メールが登録されていない',
    NotEmail: 'メールは空けてはいけない!',
    submit: '提出する',
    findemail: 'メールアドレスを取り戻す?',
    finish: '完成',
    authcodeerror: '検証コードが正しくない',
    authcodeemail: 'メールで検証してください',
    notemail: 'メールアドレスに記入していない',
    findphone: '携帯番号を取り戻す?'
  },
  loginswiper: {
    goregister: 'すぐ登録する'
  },
  mynews: {
    masternews: '飼い主さん情報',
    mastername: 'ニックネーム',
    mastersex: '性別',
    masteremail: 'メールアドレス',
    masterphone: '連絡用電話番号',
    masteradr: '連絡用住所'
  },
  mynewsedit: {
    EditMasterNews: 'マスター情報を編集する',
    setImg: 'ヘッドの写真を設置する',
    EnterMastername: 'ニックネームを入力する',
    ChoiceSex: '性別を選択する',
    EnterMasterphone: '連絡の電話番号を入力してください',
    EnterMasteradr: '連絡先を入力してください',
    finish: '完成',
    boy: '男',
    girl: '女',
    failure: 'アップロード失敗!'
  },
  register: {
    registerphone: '携帯番号を登録する',
    // registeremail:'メールアドレスを登録する',
    registeremail: '郵便受け登録',
    //手机注册
    registeredphone: 'この携帯番号はすでに登録されている',
    //邮箱注册
    registeredemail: 'このメールアドレスはすでに登録されている',
    enterPsd: 'パスワードを入力する',
    againEnterPsd: 'パスワードを再入力',
    notAgainPsd: 'パスワードがなければならない'
  },
  registerfalse: {
    failurelink: 'リンクが無効になっている'
  },
  resetemailproving: {
    lastone: 'メールボックスにメールを送信しました：',
    lasttwo: '指示に従ってパスワードをリセットし、正しく保存してください！',
    resetPsdEmail: 'メールボックスに入ってパスワードをリセットする'
  },
  resetsuccess: {
    changesuccess: 'リセット成功、おめでとう'
  },
  //Sharon2018-11-13
  findPetInfo: {
    bound: 'デバイスは既にバインドされている',
    enterplatform: 'プラットフォームに入る'
  },
  qrFindError: {
    deviceError: 'この装置は識別されない,',
    toPlat:'カスタマーサービスに連絡してください'
  },
  releaseSearch: {
    report: '捜査協力呼びかけを公開する',
    title: '20文字以下のタイトルを入力してください',
    nottitle: 'タイトルが記入されていない',
    decription: 'できるだけ詳しい状況を書き込みください',
    notneed: '内容は記入されていない',
    losttime: '迷子になった時間',
    choicetime: '日付を選択する',
    nottime: '時間は選択していない',
    lostadr: '迷子になった場所(下をクリックして場所を変更出来る)',
    choicepet: 'ペットを選択していない',
    petImg: 'ペット写真（3枚まで）',
    opencontact: '連絡方法を公開する',
    choice: '選択してください',
    notcontact: 'この連絡先がないので、変更または再記入してください。',
    mastermessage:'飼主のメッセージ',
  	preserve:'保存',
  	cancel:'キャンセル',
  	decription: 'ペットを見つけて頂いてありがとうございます。今ペットのオーナーは非常に心配しています。オーナに連絡して頂けますでしょうか。よろしくお願いします。',
  },
  connectDevice: {
    accessnetwork: 'DOGNESS人工知能デバイスネットワークにアクセス',
    configuration: '携帯電話のQRコードが生成した後、デバイスのレンズから約15cm離れて、微調整して、デバイスカメラがQRコードを認識しやすくなる'
  },
  createQrCode: {
    wifiname: '接続中のWi-Fi名を入力してください',
    wifipassword: '接続中のWi-Fiパスワードを入力してください',
    QrCode: 'QRコードを生成する'
  },
  activation:{
  	sure:'有効にする。',
  	success:'完了',
  },
  menu:{
  	changeinfo:'情報を編集',
  	mytag:'マイタッグ',
  	scanningrecord:'スキャン記録'
  },
  lossinfo:{
  	sure:'捜索依頼を投稿',
  	close:'閉める'
  },
  petstatus:{
  	petinfo:'ペットが行方不明になるのを防ぐために、ペット情報を記入して下さい。',
  	petlookafter:'ペットが迷子にならないよう心掛けて下さい。',
  	petmissing:'私は迷子になった、私を家に連れて行ってください！',
  	petfinding:'捜査依頼が投稿されました。情報をお待ち下さい。',
  },
  changeinfos:{
  	sure:'確認',
  	changeinfostitle:'スキャン記録'
  },
  introduction:{
  	sure:'はじめに'	,
  	introductiontitle:'共同プラットフォームについて',
  	introduction01:'全ての思いやりのある人にあなたの犬を守らせましょう。',
  	introduction02:'たった3つのステップが必要です。：',
  	introduction03:'ログインしてあなたとペットの情報を登録します。',
  	introduction04:'一旦有効にすると、QRコードをスキャンした利用者がこの情報を見ることが出来ます。',
  	introduction05:'あなたのペットが迷子になった場合は、捜索依頼を投稿することが出来ます。ペットのタグにあるQRコードがスキャンされると、あなたはペットの現在の位置を知ることが出来ます。そして、スキャンした人と連絡して、ペットができるだけ早く戻ってくるようにします。',
  },
  deviceManage: {
    proName: '製品名',
    proType: '製品種類',
    proNum: '製品番号',
    boundpet: 'ペットをバインドする',
    noboundpet: 'バインドされていないペット',
    nopet: 'またペットを追加していない',
    reportfindnews: '迷子犬捜し情報を公開する',
    unbind: 'デバイスをアンバインドする',
    failure: '失敗'
  },
  binddevice: {
    boundDevice: 'デバイスをバインドする:',
    clickAddDevice: 'デバイスの追加をクリックする'
  },
  changepet: {
    name: '小小柴',
    surebind: 'バインディングを決定する'
  },
  choosePet: {
    mycute: '愛犬・愛猫',
    choicecute: '愛犬・愛猫を選択する'
  },
  //提示框
  prompt: {
    noactivationemail: 'ユーザーのアカウントはまだアクティブにしていまない！メールを再送信しました。メールボックスに入ってアカウントをアクティブにしてください！',
    messageerror: 'アカウントまたはパスワードのエラー',
    loginswiperError: 'ユーザ名またはパスワードの入力エラー',
    notapply: '提供していない',
    nocontact: '連絡先がない',
    openemail: 'メールアドレスを公開する',
    openphone: '携帯番号を公開する',
    openall: 'メールアドレスと携帯番号を公開する',
    notChoicePet: 'ペットは選択していない',
    notChoiceConcact: '連絡先の公開は未選択',
    notChoiceImg: 'ペット写真は未選択',
    found: '愛犬・愛猫の迷子捜し情報はすでに公開している',
    notdevice: 'ペットはデバイスにバインドされていない',
    scan: 'サードパーティのスイープ機能を使用してください',
    scanQrCode: 'QRコードをデバイスカメラに合わせてください',
    bindpetsuccess: 'ペットはバインド成功!',
    removedevice: 'デバイスのバインドを解除してもよろしいですか？',
    cancelchange: '修正をキャンセルする?',
    delete: 'この操作は、ファイルを永久に削除するが、続行するかどうか?',
    promptcancel: 'プロンプト',
    remove: 'バインディングを解除する',
    sure: '確定',
    cancel: 'キャンセル',
    cancelbind: 'アンバインド成功',
    deletesuccess: '削除成功',
    findingpet: 'このペットは現在捜している!',
    notcancel: 'アンバインドをキャンセルした',
    feeder: 'ドッグネス人工知能給餌器',
    bluetooth: 'Bluetooth歩数計',
    robot: 'ドッグネスペット遊ぶ「ペットボー」',
    QrCode: 'ドッグネス迷子犬捜し用ペンダント',
    necklace: 'ドッグネス人工知能首輪',
    mianbaoji: 'ドッグネス　ミニ「ペットボー」',
    toushiqi: 'ドッグネスカメラ搭載「ドッグアソボー」',
    sending: 'メール送信中、お待ちください！',
    boy: '男の子',
    girl: '女の子',
    notpetimg: 'ペットのアバター写真は追加されていない',
    againlogin: 'アカウントのログインが切れました。もう一度ログインしてください',
    contentInteval: '失敗を保存する',
    addfailure: '一部の情報が入力されていないため、追加に失敗!',
    nopetlifepic: 'ペットの写真がなければならない',
    cantdelete: 'ペットは捜索中またはアンバインドされていないため、削除できない!',
    canceldelete: '削除をキャンセルする',
    ycanceldelete: '削除をキャンセルした',
    choosePetone: '捜索中のペットは、バインドできない',
    choosePettwo: 'ペットの選択は失敗',
    header: 'ユーザーログインがタイムアウトしました。再度ログインしてください',
    slider: 'このペットをアンバインドしますか?',
    yslider: 'ペットをアンバインドする',
    finding: '捜索中!',
    nodevice: 'デバイスが存在しないため、カスタマーサービスに連絡してください',
    bindfailure: 'バインディングは失敗し、デバイスは別のユーザーによってログインされている',
    contactkf: 'システム故障、カスタマーサービス担当者に連絡してください。',
    noscan: 'スキャン記録はまたない',
    noApply:'あなたのブラウザは当分このタイプの共有をサポートしません!',
    showTimes:'この装置のスキャン回数は',
    noexpression:'表情入力はサポートされていません。',
  },
  countries: {
    china: '中国',
    hongkong: '中国香港',
    macau: '中国マカオ',
    taiwan: '中国台湾',
    Albania: 'Albania',
    Algeria: 'Algeria',
    Afghanistan: 'Afghanistan',
    Argentina: 'Argentina',
    UnitedArabemirates: 'UnitedArabemirates',
    Aruba: '阿鲁巴',
    America: 'アメリカ',
    Germany: 'ドイツ',
    Japan: '日本',
    Oman:'阿曼',
    azerbaijan:'阿塞拜疆',
    Egypt:'埃及',
    Ethiopia:'埃塞俄比亚',
    Ireland:'爱尔兰',
    Estonia:'爱沙尼亚',
    Andorra:'安道尔',
    Angola:'安哥拉',
    anguilla:'安圭拉',
    AntiguaAndBarbuda:'安提瓜和巴布达',
    Austria:'奥地利',
    Australia:'澳大利亚',
    Barbados:'巴巴多斯',
    PapuaNewGuinea:'巴布亚新几内亚',
    Bahamas:'巴哈马',
    Pakistan:'巴基斯坦',
    Paraguay:'巴拉圭',
    Palestine:'巴勒斯坦',
    bahrain:'巴林',
    panama:'巴拿马',
    Brazil:'巴西',
    belarus:'白俄罗斯',
    Bermuda:'百慕大',
    Bulgaria:'保加利亚',
    NorthKorea:'北朝鲜',
    NorthernMarianaIslands:'北马里亚纳群岛',
    BacNinh:'北宁',
    Belgium:'比利时',
    Iceland:'冰岛',
    PuertoRico:'波多黎各',
    Poland:'波兰',
    BosniaAndHerzegovina:'波斯尼亚和黑塞哥维那',
    Bolivia:'玻利维亚',
    Belize:'伯利兹',
    BozWana:'博兹瓦纳',
    Bhutan:'不丹',
    BurkinaFaso:'布基纳法索',
    Burundi:'布隆迪',
    EquatorialGuinea:'赤道几内亚',
    Denmark:'丹麦',
    EastTimor:'东帝汶',
    Togo:'多哥',
    Dominica:'多米尼加',
    DominicanRepublic:'多明尼加共和国',
    Russia:'俄国',
    Ecuador:'厄瓜多尔',
    eritrea:'厄立特里亚',
    France:'法国',
    TheFaroeIslands:'法罗群岛',
    FrenchPolynesia:'法属波利尼西亚',
    Vatican:'梵蒂冈',
    ThePhilippines:'菲律宾',
    Fiji:'斐济',
    Finland:"芬兰",
    CapeVerde:'佛得角',
    Franks:'佛兰克群岛',
    Gambia:'冈比亚',
    Congo:'刚果民主共和国',
    Colombia:'哥伦比亚',
    CostaRica:'哥斯达黎加',
    grenada:'格林纳达',
    Greenland:'格陵兰',
    Georgia:'格鲁吉亚',
    Cuba:'古巴',
    Guam:'关岛',
    Guyana:'圭亚那',
    kazakhstan:'哈萨克斯坦',
    Haiti:'海地',
    Korea:'韩国',
    Netherlands:'荷兰',
    NetherlandsAntilles:'荷属安的列斯',
    Montenegro:'黑山',
    Honduras:'洪都拉斯',
    Kiribati:'基里巴斯',
    djibouti:'吉布提',
    kyrgyzstan:'吉尔吉斯斯坦',
    guinea:'几内亚',
    Canada:'加拿大',
    Ghana:'加纳',
    Gabon:'加蓬',
    Cambodia:'柬埔寨',
    CzechRepublic:'捷克共和国',
    Zimbabwe:'津巴布韦',
    Cameroon:'喀麦隆',
    Qatar:'卡塔尔',
    CaymanIslands:'开曼群岛',
    Comorin:'科摩罗',
    Kuwait:'科威特',
    Croatia:'克罗地亚',
    Kenya:'肯尼亚',
    cookIslands:'库克群岛',
    Latvia:'拉脱维亚',
    Lesotho:'莱索托',
    Laos:'老挝',
    Lithuania:'立陶宛',
    Liberia:'利比里亚',
    Libya:'利比亚',
    Liechtenstein:'列支敦士登',
    reunion:'留尼汪',
    Luxembourg:'卢森堡',
    Rwanda:'卢旺达',
    Romania:'罗马尼亚',
    Madagascar:'马达加斯加',
    Maldives:'马尔代夫',
    Malta:'马耳他',
    Malawi:'马拉维',
    Malaysia:'马来西亚',
    Macedonia:'马其顿',
    MarshallIslands:'马绍尔群岛',
    Mauritius:'毛里求斯',
    Mauritania:"毛里塔尼亚",
    AmericanSamoa:'美属萨摩亚',
    Mongolia:'蒙古',
    Montserrat:'蒙特塞拉特',
    Bangladesh:'孟加拉国',
    Peru:'秘鲁',
    Micronesia:'密克罗尼西亚',
    Burma:'缅甸',
    Moldova:'摩尔多瓦',
    Monaco:'摩纳哥',
    Mozambique:'莫桑比克',
    Mexico:'墨西哥',
    Namibia:'纳米比亚',
    SouthAfrica:'南非',
    SouthSudan:'南苏丹',
    Nauru:'瑙鲁',
    Nicaragua:'尼加拉瓜',
    Nepal:'尼泊尔',
    Niger:'尼日尔',
    Nigeria:'尼日利亚',
    niue:'纽埃',
    Norway:'挪威',
    Palau:'帕劳',
    Portugal:'葡萄牙',
    Sweden:'瑞典',
    Switzerland:'瑞士',
    Salvador:'萨尔瓦多',
    Samoa:'萨摩亚',
    Serbia:'塞尔维亚',
    SierraLeone:'塞拉利昂',
    Senegal:'塞内加尔',
    Cyprus:'塞浦路斯',
    Seychelles:'塞舌尔',
    SaudiArabia:'沙特阿拉伯',
    SaoTomeandPrincipe:'圣多美和普林西比',
    SaintHelena:'圣赫勒拿',
    SaintKittsAndNevis:'圣基茨和尼维斯',
    SaintLucia:'圣卢西亚',
    SanMarino:'圣马力诺',
    SaintPierreandMiquelon :'圣皮埃尔和密克隆',
    SriLanka:'斯里兰卡',
    Slovakia:'斯洛伐克',
    Slovenia:'斯洛文尼亚',
    Swaziland:'斯威士兰',
    Sudan:'苏丹',
    Surinam:'苏里南',
    SolomonIslands:'所罗门群岛',
    Tajikistan:'塔吉克斯坦',
    Thailand:'泰国',
    Tanzania:'坦桑尼亚',
    Tonga:'汤加',
    Tunisia:'突尼斯',
    Tuvalu:'图瓦卢',
    Turkey:'土耳其',
    Turkmenistan:'土库曼斯坦',
    Tokelau:'托克劳',
    Vanuatu:'瓦努阿图',
    Guatemala:'危地马拉',
    Venezuela:'委内瑞拉',
    Brunei:'文莱',
    Uganda:'乌干达',
    Ukraine:'乌克兰',
    Uruguay:'乌拉圭',
    Uzbekistan:'乌兹别克斯坦',
    Spain:'西班牙',
    WesternSahara:'西撒哈拉',
    Greek:'希腊',
    Singapore:'新加坡',
    NewCaledonia:'新喀里多尼亚',
    NewZealand:'新西兰',
    Hungary:'匈牙利',
    Syria:'叙利亚',
    Jamaica:'牙买加',
    Armenia:'亚美尼亚',
    Yemen:'也门',
    Iraq:'伊拉克',
    Iran:'伊朗',
    Israel:'以色列',
    Italy:'意大利',
    India:'印度',
    Indonesia:'印度尼西亚',
    England:'英国',
    BVI:'英属维尔京群岛',
    BIOT:'英属印度洋领地',
    Jordan:'约旦',
    Vietnam:'越南',
    Zambia:'赞比亚',
    Chad:'乍得',
    Gibraltar:'直布罗陀',
    Chile:'智利',
    CentralAfricanRepublic:'中非共和国'
  }

}


// WEBPACK FOOTER //
// ./src/i18n/langs/ja.js